import client from './client'

const apiBasePath = '/api/admin/sendmail/'

export default {
  search: form => client.post(apiBasePath + 'search', form),
  send: form => client.post(apiBasePath + 'send', form),
  history: () => client.post(apiBasePath + 'history'),
  historyDetail: mailSendId => client.post(apiBasePath + 'historyDetail', mailSendId),
  historyTo: mailSendId => client.post(apiBasePath + 'historyTo', mailSendId)
}
